import { Form, Alert, Typography, Button, Modal, Tooltip } from "antd";
import { useEffect, useState, useRef, useCallback } from "react";
import apiCalls from "src/api/apiCalls";
import { connect } from 'react-redux';
import Loader from "../shared/loader.component";
import ConfigKey from "../../assets/images/configKey.svg"

const { Paragraph } = Typography;

const APIKeys = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [form] = Form.useForm();
  const [tokenKey, setTokenKey] = useState('');
  const [loader, setLoader] = useState()
  const [btnLoader, setBtnLoader] = useState()
  const shouldLog = useRef(true);
  const [configModal, setConfigModal] = useState(false)

   const handleconfigModal = useCallback(() => {
          setConfigModal(false)
      }, [])

  useEffect(() => {
    form.resetFields(); setErrorMessage(null)
    if (shouldLog.current) {
      shouldLog.current = false; generateToken();
    }
  }, []);
  const generateToken = async () => {
    try {
      setLoader(true)
      const response = await apiCalls.getToken();
      if (response.ok) {
        setTokenKey(response.data?.token || '');
        form.setFieldsValue({ tokenKey: response.data?.token || '' });
        setErrorMessage(null); setLoader(false)
      } else {
        setErrorMessage(apiCalls.isErrorDispaly(response)); setLoader(false)
      }
    } catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error)); setLoader(false)
    }
  }
  const generateTokenKey = async () => {
    try {
      setBtnLoader(true)
      const response = await apiCalls.getTokenKey();
      if (response.ok) {
        const res = await apiCalls.getToken();
        setTokenKey(res.data?.token || '');
        form.setFieldsValue({ tokenKey: res.data?.token || '' });
        setErrorMessage(null); setBtnLoader(false)
        setConfigModal(false)
      } else {
        setErrorMessage(apiCalls.isErrorDispaly(response)); setBtnLoader(false);setConfigModal(false)
      }
    } catch (error) {
      setErrorMessage(apiCalls.isErrorDispaly(error)); setBtnLoader(false);setConfigModal(false)
    }
  }
  const saveAddCards = useCallback(() => {
    generateTokenKey();
  },[])
  const customerTokenGenarateHandler=useCallback(()=>{
    setConfigModal(true)
  },[])
  const closeErrorMsgHandler=useCallback(()=>{
    setErrorMessage(null)
  },[])
  return (
    <div className=''>
      {errorMessage !== null && (
        <Alert
          className='mb-6'
          type="error"
          description={errorMessage}
          onClose={closeErrorMsgHandler}
          showIcon
          closable
        />
      )}

      {loader ? <Loader /> :
        <div className="border border-StrokeColor p-4 rounded-5"><h2 className='text-labelGrey text-base font-medium mb-1'>Customer Token</h2>
          <Form
            form={form}
            autoComplete="off"
            initialValues={{ tokenKey: tokenKey }}
          >

            <div className="">

              {tokenKey && <Paragraph className="bg-kendoHover text-base font-normal text-whiteText mt-0 py-3 !mb-0 px-5 rounded-5">
                {tokenKey}
              </Paragraph>}
              <div className="mt-5">
                <Button className='primary-btn' onClick={customerTokenGenarateHandler} disabled={tokenKey === '' ? false : true}>
                  <span>Generate</span>
                </Button>  </div>
            </div>
            <Modal
              open={configModal}
              onCancel={handleconfigModal}
              title={'Customer Token'}
              maskClosable={false}
              closeIcon={
                <Tooltip title="Close">
                  <span className="icon close c-pointer" />
                </Tooltip>
              }
              footer={false}>
              <div className='text-center p-3.5'>
                <div>
                  <img src={ConfigKey} alt="" className="mx-auto" />
                </div>
                <p className="text-center text-2xl font-semibold mb-3 py-3">Once you generate Customer Token, this will be disabled. You can’t Modified .</p>
              </div>
              <div className="">
                <Button key="submit" className='mt-3 mb-3 primary-btn left-80' onClick={saveAddCards} loading={btnLoader}>
                  <span>Ok</span>
                </Button>  </div>
            </Modal>
          </Form>
        </div>}
    </div>
  )
}
const connectStateToProps = ({ oidc }) => {
  return { userDetails: oidc?.user.currentUser }
}
export default connect(connectStateToProps)(APIKeys);